import React, { useRef, useEffect, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import "../../Styles/ReMap.css";
import { world_religion } from "./WorldReligion";
import Legend from "./Legend";
import axios from "axios";
import TempButtons from "./TempButtons";
import Religious_data from "../../Religious_data";
import Chart from "./Chart";

mapboxgl.accessToken = 'pk.eyJ1IjoiZWRtYW4iLCJhIjoiY2syNWs1ajk3MGM2NjNua3gxYTNhdWpkOSJ9.ngu-SlVjhLdLBPyDFFsIBw';

export default function ReMap({religion}) {
    const mapContainer = useRef(null);
    const map = useRef(null);
    const [lng, setLng] = useState(-70.9);
    const [lat, setLat] = useState(42.35);
    const [zoom, setZoom] = useState(1);
    const [firstReligion, setFirstReligion] = useState("...");
    const [secondReligion, setSecondReligion] = useState("...");
    const [province, setProvince] = useState("...");
    const [country, setCountry] = useState("...");
    const [numerical, setNumerical] = useState(null);
    const [year, setYear] = useState("...");
    const [dataSource, setDataSource] = useState("...");
    const [display, setDisplay] = useState("map");
    const buddhismSubs= ["Tibetan","Theravada","Mahayana"];
    let hoveredStateId = null;

    const options = [
        {
          name: "Buddism",
          description: "Estimate total GDP in millions of dollars",
          property: "gdp_md_est",
          stops: [
            [0, "#f8d5cc"],
            [1000, "#f4bfb6"],
            [5000, "#f1a8a5"],
            [10000, "#ee8f9a"],
          ],
        },
        {
          name: "Christian",
          description: "Estimated total population",
          property: "pop_est",
          stops: [
            [0, "#ec739b"],
            [1000000, "#dd5ca8"],
            [5000000, "#c44cc0"],
            [10000000, "#9f43d7"],
          ],
        },
      ];

    useEffect(() => {
        if (map.current) return; // initialize map only once
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/light-v10',
            center: [lng, lat],
            zoom: zoom
        });
        map.current.addControl(new mapboxgl.NavigationControl());
    }, []);

    useEffect(() => {
        map.current.on('load', () => {
            map.current.addSource('world_religion', {
                'type': 'vector',
                'url': 'mapbox://edman.BRI_Religion_MTS'
            });
            map.current.addLayer(world_religion, 'state-label');
            map.current.addLayer({
                'id': 'state-fills',
                'type': 'fill',
                'source': 'world_religion',
                'source-layer': 'BRI_Religion_Layer',
                'layout': {},
                'paint': {'fill-color': '#627BC1','fill-opacity': ['case',['boolean', ['feature-state', 'hover'], false],1,0]}
                }
            );
        });

        map.current.on('mousemove', 'world_religion', (e) => {
            if(e.features.length>0){
                console.log(e.features[0])
            }
            
        });
        map.current.on('mousemove', 'state-fills', (e) => {
            if (e.features.length > 0) {
                if (hoveredStateId !== null) {
                    map.current.setFeatureState(
                    { source: 'world_religion', sourceLayer: 'BRI_Religion_Layer', id: hoveredStateId },
                    { hover: false }
                    );
                }
                hoveredStateId = e.features[0].id;
                map.current.setFeatureState(
                    { source: 'world_religion', sourceLayer: 'BRI_Religion_Layer', id: hoveredStateId },
                    { hover: true }
                );
                setFirstReligion(e.features[0].properties.HighRelig);
                setSecondReligion(e.features[0].properties.SecRelig);
                setProvince(e.features[0].properties.ProvName);
                setCountry(e.features[0].properties.Country);
                setNumerical(e.features[0].properties.Numerical);
                setYear(e.features[0].properties.Year);
                setDataSource(e.features[0].properties.DataSource);
            }
        });
        map.current.on('mouseleave', 'state-fills', () => {
            if (hoveredStateId !== null) {
            map.current.setFeatureState(
            { source: 'world_religion', sourceLayer: 'BRI_Religion_Layer', id: hoveredStateId },
            { hover: false }
            );
            }
            hoveredStateId = null;
            }
        );
        map.current.setRenderWorldCopies(false);
        map.current.flyTo({
          center: [80, 35],
          zoom: 2,
        });

        map.current.on('idle', () => {
          map.current.setFilter("world_religion", [
            "any",
            ["==", "HighRelig", "Buddhists(Tibetan Buddhism)"],
            ["==", "HighRelig", "Buddhists(Theravada)"],
            ["==", "HighRelig", "Buddhists(Mahayana)"],
          ]);
              })
    }, []);
    
    //useEffect(() => {
    //    map.current.on('idle', () => {
    //    map.current.setFilter('world_religion', ['==', 'HighRelig', 'East Asian Religiosity'])
    //    })
    //}, []);

    return (

        <div>
            {display==="map"&&(
                <div className="displayButtons">
                    <button style={{backgroundColor:"grey"}} onClick={()=>{setDisplay("map");window.location.reload();}}>Mapping</button>
                    <button onClick={()=>setDisplay("chart")}>Chart Data</button>
                </div>
            )}

            {display==="chart"&&(
                <div className="displayButtons">
                    <button onClick={()=>{setDisplay("map");window.location.reload();}}>Mapping</button>
                    <button style={{backgroundColor:"grey"}} onClick={()=>setDisplay("chart")}>Chart Data</button>
                </div>
            )}

            {/* <TempButtons map={map} />
            
            <div className="left">
                <button
                    onClick={async () => {
                    // const res = await axios.get("http://api.positionstack.com/v1/forward?access_key=5c5e436e04f0254e51a8f5038d4167dd&query=Kansas City&country=US")
                    const res = await axios.get(
                        "http://api.positionstack.com/v1/forward?access_key=5c5e436e04f0254e51a8f5038d4167dd&query=shaanxi&country=CN"
                    );

                    console.log(res);
                    // map.setCenter([res.data.data[0].longitude, res.data.data[0].latitude]);
                    map.current.flyTo({
                        center: [res.data.data[0].longitude, res.data.data[0].latitude],
                        zoom: 3,
                    });
                    }}
                >
                    Fly to China
                </button>
              </div>*/}
            {display==="map" &&
                <>
                    {buddhismSubs.map((e) => <Legend sub={e}/>)}
                    <div ref={mapContainer} className="map-container" />
                    <div className="infoDisplay">
                        <div><h3>Country:</h3> {country} </div>
                        <div><h3>Province:</h3> {province} </div>
                        <div><h3>First Religion:</h3> {firstReligion} {numerical}%</div>
                        <div><h3>Second Religion:</h3> {secondReligion||"..."}</div>
                        <div><h3>Year:</h3> {year}</div>
                        <div><h3>Data Source:</h3> {dataSource}</div>
                    </div>
                </>
                
            }
            {display==="chart" &&<Chart />}
        </div>
        
    );
}

